const reducer = (state = {}, action) => {
  switch (action.type) {
    case 'SET_SHIPPING_ADDRESS': {
      return {
        ...state,
        shippingAddress: action.data,
      };
    }
    case 'SEARCH_ADDRESS': {
      return {
        ...state,
        searchAddressListAPI: true,
      };
    }
    case 'SEARCH_ADDRESS_LIST': {
      return {
        ...state,
        searchAddressList: action.data,
        searchAddressListAPI: false,
      };
    }
    case 'SET_PLACE': {
      return {
        ...state,
        newAddress: action.data,
      };
    }
    case 'RESET_ADDRESS': {
      return {
        ...state,
        searchAddressList: [],
        newAddress: {},
        addAddressStatus: 'success',
      };
    }
    case 'ADDRESS_FAILURE': {
      return {
        ...state,
        addAddressStatus: 'fail',
      };
    }
    case 'RESET_ADDRESS_STATUS': {
      return {
        ...state,
        addAddressStatus: '',
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
